export const SCHEMA_NAME = "ServiceDocuments";

export const FIELDS = {
  SERVICE_DOCUMENT_ID: "serviceDocumentID",
  WARRANT_ID: "warrantID",
  CIVIL_PAPER_DEFENDANT_ID: "civilPaperDefendantID",
  BUSINESS_ID: "businessID",
  DATE_COMPLETED: "dateCompleted",
  TIME_COMPLETED: "timeCompleted",
  COMPLETION_STATUS: "completionStatus",
  COMMENTS: "comments",
  PERSON_TO_BE_SERVED_JACKET_ID: "personToBeServedJacketID",
  INITIATION_DATE: "initiationDate",
};
